// Native
import { useNavigate, useParams } from "react-router"

// Components
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Avatar, Box, Button, ButtonGroup, Grid, GridItem, Text, useDisclosure } from "@chakra-ui/react"
import { Icon, IconButton, Pressable, Section, Tag } from "components"

// Hooks
import { useConsultant, useConsultantNetwork } from "hooks"
import Search from "./search"

export default function Network(){

    const params = useParams()
    const consultant = useConsultant(params?.id)
    const network = useConsultantNetwork(consultant.data?.id)
    const search = useDisclosure()

    return(
    <>
    <Section title="Rede completa">
        <ButtonGroup size="xs" isDisabled={network.isFetching}>
            <Button children="Procurar consultor na rede" leftIcon={<Icon name="search" />} onClick={search.onOpen} />
            <IconButton label="Atualizar" icon="refresh" isLoading={network.isFetching} onClick={network.refetch} />
        </ButtonGroup>
    </Section>

    <Accordion>
        { network.data && Object.keys(network.data)?.map(level => <Level key={level} level={level} data={network.data?.[level]} />) }
    </Accordion>

    <Search {...search} />
    </>
    )
}

function Level({ level, data }){

    let itens = Object.keys(data)

    return(
    <AccordionItem>
        <AccordionButton>
            <h2>Nível {level} <Tag size="sm" colorScheme="orange" children={`${itens.length} cadastrados`} /></h2>
            <AccordionIcon />
        </AccordionButton>
        <AccordionPanel>
            <Grid templateColumns="1fr 1fr 1fr 1fr 1fr 1fr 1fr" gap={3}>
                { itens.map(key => <Person key={key} data={data[key]} />) }
            </Grid>
        </AccordionPanel>
    </AccordionItem>
    )
}

function Person({ data, ...props }){

    const navigate = useNavigate()

    return(
    <GridItem>
        <Pressable onClick={() => navigate(`/consultants/${data.consultant_id}`)}>
            <Box textAlign="center" p={4} borderWidth={1} borderRadius={8}>
                <Avatar name={data.name} size="sm" />
                <Text children={data.name} textTransform="capitalize" fontSize="xs" />
            </Box>
        </Pressable>
    </GridItem>
    )
}